import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 短期/少額リースの除外規定 */
enum ShortSmallLeaseExclReg {
  notApply = 'NOT_APPLY',
  apply = 'APPLY',
}

const nameConfig = {
  notApply: new Map([
    [Locale.ja, '除外規定を適用しない'],
    [Locale.en, 'Do Not Apply Exclude Regulation'],
  ]),
  apply: new Map([
    [Locale.ja, '除外規定を適用する'],
    [Locale.en, 'Apply Exclude Regulation'],
  ]),
};

const toEnum = rawValueToEnum(ShortSmallLeaseExclReg, ShortSmallLeaseExclReg.notApply);
const toDisplay = enumToName(ShortSmallLeaseExclReg, nameConfig);
const toDisplayWithPrefix = enumToName(ShortSmallLeaseExclReg, nameConfig, { prefix: true });

export const shortSmallLeaseExclReg = {
  enum: ShortSmallLeaseExclReg,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ShortSmallLeaseExclReg };
